<template>
  <div>
    <b-row v-if="product && product.skus && product.skus.length > 0">
      <b-col md="12">
        <b-card-actions
          action-collapse
          :show-loading="fetching"
        >
          <template #title>
            <b-card-title>
              {{ $t('Configurações') }}
            </b-card-title>
          </template>
          <div>
            <b-row>
              <b-col md="3">
                <FormulateInput
                  id="product-active-online"
                  v-model="product.activeOnline"
                  :type="isReadOnly ? 'status-badge' : 'switch'"
                  badge-type="yesNo"
                  :label="$t('Vender no Site?')"
                />
              </b-col>
              <b-col
                v-if="!isAssetProductType"
                md="2"
              >
                <FormulateInput
                  id="product-active-echopeja"
                  v-model="product.activeEchopeai"
                  :type="isReadOnly ? 'status-badge' : 'switch'"
                  badge-type="yesNo"
                  :label="$t('Vender no echope já?')"
                />
              </b-col>
              <b-col md="3">
                <FormulateInput
                  id="product-customer-required"
                  v-model="product.customerRequired"
                  :type="isReadOnly ? 'status-badge' : 'switch'"
                  badge-type="yesNo"
                  :label="$t('Obriga Cliente?')"
                  :instruction="$t('Quando selecionado, caso este produto esteja na venda, será obrigatório informar os dados do cliente')"
                />
              </b-col>
              <b-col md="3">
                <FormulateInput
                  id="product-featured"
                  v-model="product.featuredProduct"
                  :type="isReadOnly ? 'status-badge' : 'switch'"
                  badge-type="yesNo"
                  :label="$t('Destacar Produto?')"
                  :instruction="$t('Quando selecionado, o produto será destacado para venda nos canais online')"
                />
              </b-col>
              <b-col md="3">
                <FormulateInput
                  id="product-group-offers-beer-cooler"
                  v-model="product.offersBeerCooler"
                  :type="isReadOnly ? 'status-badge' : 'switch'"
                  :label="$t('Oferece Kit Chopeira')"
                  :instruction="$t('Quando habilitado, será oferecido o Kit Chopeira nos pedidos do app/site.')"
                />
              </b-col>
            </b-row>
            <b-row>
              <b-col md="3">
                <FormulateInput
                  id="product-unitsPerPack"
                  v-model="product.unitsPerPack"
                  :type="isReadOnly ? 'label' : 'text-number'"
                  :label="$t('Qtd. embalagem pack')"
                  :instruction="$t('Quantidade que vem na embalagem de pack. Exemplo, para long neck, o pack vem com 6 unidades. Esta é a quantidade utilizada para os múltiplos que serão exibidos no app.')"
                  :validation="product.activeB2B ? 'required' : ''"
                />
              </b-col>
              <b-col md="3">
                <FormulateInput
                  id="product-items-per-delivery-package"
                  v-model.number="product.itemsPerDeliveryPackage"
                  name="itemsPerDeliveryPackage"
                  :type="isReadOnly ? 'label' : 'number'"
                  min="1"
                  max="9999"
                  step="1"
                  validation="optional|number|min:1|max:9999"
                  :validation-messages="{
                    number: $t('PRODUCT.VALIDATION_ERROR.ITEMS_PER_DELIVERY_PACKAGE_OUT_OF_RANGE'),
                    min: $t('PRODUCT.VALIDATION_ERROR.ITEMS_PER_DELIVERY_PACKAGE_OUT_OF_RANGE'),
                    max: $t('PRODUCT.VALIDATION_ERROR.ITEMS_PER_DELIVERY_PACKAGE_OUT_OF_RANGE'),
                  }"
                  :label="$t('Itens por pacote de entrega')"
                  :instruction="$t('Quantidade de itens deste produto que cabem em um pacote de entrega.')"
                />
              </b-col>
              <b-col md="3">
                <FormulateInput
                  id="product-integrate-with-beer-cooler"
                  v-model="product.integrateWithBeerCooler"
                  :type="isReadOnly ? 'status-badge' : 'switch'"
                  badge-type="yesNo"
                  :label="$t('Integra Quiosque?')"
                  :instructions="[
                    {
                      text: $t('ATENÇÃO: Não marque esta opção para o produto de Cartão, utilize apenas para os chopes que serão instalados nas torneiras'),
                    },
                    {
                      text: $t('Quando selecionado, este produto é integrado para que possa ser ofertado na chopeira das lojas do tipo Quiosque'),
                    },
                  ]"
                />
              </b-col>
              <b-col md="3">
                <FormulateInput
                  id="product-active-b2b"
                  v-model="product.activeB2B"
                  :type="isReadOnly ? 'status-badge' : 'switch'"
                  badge-type="yesNo"
                  :label="$t('Vender no B2B?')"
                  :instruction="$t('Quando selecionado, o produto será disponibilizado para venda B2B')"
                />
              </b-col>
              <b-col 
                v-if="product.activeB2B" 
                md="3"
              >
                <FormulateInput
                  id="product-b2b-quantity-b2b"
                  v-model="product.unitsPerPackB2B"
                  :type="isReadOnly ? 'label' : 'text-number'"
                  :class="product.activeB2B ? 'required' : ''"
                  :label="$t('Qtd. embalagem B2B')"
                  :instruction="$t('Quantidade que vem na embalagem para venda B2B. Exemplo, para long neck, o pack vem com 6 unidades. Esta é a quantidade mínima na venda B2B e também o múltiplo que será usado (não será permitido quantidades quebradas, apenas múltiplos da quantidade informada neste campo).')"
                  :validation="product.activeB2B ? 'required' : ''"
                />
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <FormulateInput
                  id="product-tags"
                  v-model="product.tags"
                  :type="isReadOnly ? 'label' : 'tags'"
                  :label="$t('Tags')"
                  :placeholder="$t('Digite a tag e tecle Enter')"
                  :size="'lg'"
                  :tag-variant="'secondary'"
                  :instruction="$t('Digite a tag e tecle Enter')"
                  multiple
                />
              </b-col>
            </b-row>
          </div>
        </b-card-actions>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12">
        <b-card-actions
          action-collapse
        >
          <template #title>
            <b-card-title>
              {{ $t('Configurações de Estoque') }}
            </b-card-title>
          </template>
          <div>
            <configuration-table 
              :configurations="skuConfigurations" 
              @add-configuration="openSidebar"
              @update-configuration="openSidebar"
              @delete-configuration="deleteConfiguration"
            />
            <configuration-sidebar 
              ref="configurationSidebar" 
              @create="createConfiguration"
              @update="updateConfiguration"
            />
          </div>
        </b-card-actions>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BRow, BCol, BCardTitle } from 'bootstrap-vue'
import { mapState, mapGetters } from 'vuex'
import BCardActions from '@/@core/components/b-card-actions/BCardActions.vue'
import ConfigurationTable from './ConfigurationTable.vue'
import ConfigurationSidebar from './ConfigurationSidebar.vue'

export default {
  name: 'SkuConfiguration',
  components: {
    BRow,
    BCol,
    ConfigurationTable,
    ConfigurationSidebar,
    BCardActions,
    BCardTitle
  },
  props: {
    fetching: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState('pages/catalog/products/productMaintain', ['product', 'isReadOnly']),
    ...mapGetters('pages/catalog/products/productMaintain', ['skuConfigurations']),
    ...mapGetters('pages/catalog/products/productMaintain', [
      'isAssetProductType',
    ]),
  },
  methods: {
    openSidebar(item) {
      this.$refs.configurationSidebar.show(item)
    },
    createConfiguration(config) {
      this.$emit('add-configuration', config)
    },
    updateConfiguration(config) {
      this.$emit('update-configuration', config)
    },
    deleteConfiguration(config) {
      this.$emit('delete-configuration', config)
    },
  },
}
</script>

<style scoped></style>
